export const COUNTRIES = [
  {
    name: "China",
    from: "Transcripts from chuzhong and gaozhong (middle and senior high school) are assessed credit-by-credit, with English translation handled alongside you.",
    path: "Students typically complete six to eight Grade 12 University-level credits — ENG4U, Advanced Functions (MHF4U) and Calculus (MCV4U) are the most common set.",
    note: "No Gaokao required: Canadian universities admit on the OSSD itself, plus proof of English proficiency.",
  },
  {
    name: "India",
    from: "CBSE, ICSE and state-board transcripts are mapped to Ontario equivalents, so you rarely repeat what you have already mastered.",
    path: "Most students take the eight 4U/M credits their target program lists — science and commerce pathways (SBI4U, SCH4U, MCV4U, CIA4U) are frequent picks.",
    note: "Canadian universities will almost always ask for IELTS — book your test date early and prepare alongside your courses.",
  },
  {
    name: "Nigeria",
    from: "WAEC, NECO and other senior-secondary results are assessed on submission; English-medium schooling makes the academic transition smooth.",
    path: "Students commonly pair ENG4U with the sciences for nursing, engineering and business offers — SBI4U, SCH4U and MHF4U are the usual line-up.",
    note: "Even with English-medium schooling, many universities still require IELTS or TOEFL — confirm each program's minimum score before applying.",
  },
  {
    name: "Philippines",
    from: "DepEd K-12 senior-high transcripts are reviewed credit-by-credit, including the STEM, ABM, HUMSS and TVL strands.",
    path: "Future nursing and health-science students usually take SBI4U, SCH4U and ENG4U; business streams take BBB4M and CIA4U.",
    note: "Canada is a top destination for Filipino graduates — plan your university intake (fall or winter) around your EGOS finish date.",
  },
];
